// extracted by mini-css-extract-plugin
export var container = "_nc-0";
export var dotAnimation = "_nc-2";
export var dotsLoading = "_nc-1";